var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-table-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: {
            "body-style": { padding: "0 20px 20px", position: "relative" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "div",
            { ref: "headerBox", staticClass: "clearfix" },
            [
              _vm.tabs && _vm.tabs.length > 0
                ? _c(
                    "el-tabs",
                    {
                      staticClass: "list-tabs mb5",
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabNew,
                        callback: function ($$v) {
                          _vm.activeTabNew = $$v
                        },
                        expression: "activeTabNew",
                      },
                    },
                    _vm._l(_vm.tabs, function (tab, index) {
                      return _c(
                        "el-tab-pane",
                        {
                          key: index,
                          attrs: { label: tab.label, name: tab.name },
                        },
                        [_vm._t("tab-" + tab.name, null, { tab: tab })],
                        2
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._t("table-header"),
          _c(
            "el-table",
            _vm._b(
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "table",
                staticClass: "mt20",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData.data,
                  size: _vm.size,
                  height: _vm.height,
                  "row-key": _vm.rowKey,
                  "highlight-current-row": _vm.highlightCurrentRow,
                },
                on: {
                  "selection-change": _vm.handleSelectionChange,
                  "row-click": _vm.handleRowClick,
                  "row-dblclick": _vm.handleRowDblClick,
                },
              },
              "el-table",
              _vm.tableProps,
              false
            ),
            [
              _vm.showSelection
                ? _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: _vm.selectionWidth,
                      selectable: _vm.selectable,
                    },
                  })
                : _vm._e(),
              _vm.expandRow
                ? _c("el-table-column", {
                    attrs: { type: "expand", width: _vm.expandWidth },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [_vm._t("expand", null, { row: props.row })]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _vm._l(_vm.columns, function (column, index) {
                return [
                  column.type === "expand"
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            type: column.type,
                            width: column.width,
                            fixed: column.fixed,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm._t(column.slotName, null, {
                                      row: props.row,
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    : column.type === "selection"
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            type: column.type,
                            width: column.width,
                            fixed: column.fixed,
                            selectable: column.selectable,
                          },
                        }),
                      ]
                    : column.type === "image"
                    ? [
                        _c("el-table-column", {
                          attrs: { prop: column.prop, width: "60" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "demo-image__preview line-heightOne",
                                      },
                                      [
                                        _c("el-image", {
                                          attrs: {
                                            src: scope.row[column.prop],
                                            "preview-src-list": [
                                              scope.row[column.prop],
                                            ],
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    : column.type === "switch"
                    ? [
                        _c("el-table-column", {
                          attrs: {
                            prop: column.prop,
                            label: column.label,
                            width: column.width,
                            "min-width": column.minWidth,
                            fixed: column.fixed,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.checkPermi([column.permission])
                                      ? _c("el-switch", {
                                          attrs: {
                                            "active-value":
                                              column.activeValue || true,
                                            "inactive-value":
                                              column.inactiveValue || false,
                                            disabled: column.disabled || false,
                                            "active-text":
                                              column.activeText || "显示",
                                            "inactive-text":
                                              column.inactiveText || "隐藏",
                                          },
                                          on: {
                                            change: function (value) {
                                              return _vm.handleSwitchChange(
                                                scope.row,
                                                value,
                                                column
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row[column.prop],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                column.prop,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row[column.prop]",
                                          },
                                        })
                                      : _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row[column.prop]
                                                  ? column.activeText || "显示"
                                                  : column.inactiveText ||
                                                      "隐藏"
                                              ) +
                                              " "
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ]
                    : [
                        _c("el-table-column", {
                          attrs: {
                            prop: column.prop,
                            label: column.label,
                            width: column.width,
                            "min-width": column.minWidth,
                            fixed: column.fixed,
                            align: column.align,
                            "header-align": column.headerAlign,
                            sortable: column.sortable,
                            resizable: column.resizable,
                            "show-overflow-tooltip": column.showOverflowTooltip,
                            formatter: column.formatter,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    column.slotName
                                      ? _vm._t(column.slotName, null, {
                                          row: props.row,
                                          index: props.$index,
                                          column: column,
                                        })
                                      : [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                column.formatter
                                                  ? column.formatter(
                                                      props.row,
                                                      props.column,
                                                      props.row[column.prop]
                                                    )
                                                  : props.row[column.prop]
                                              ) +
                                              " "
                                          ),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                ]
              }),
            ],
            2
          ),
          _vm.showPagination
            ? _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": _vm.pageSizes,
                      "page-size": _vm.pagination.pageSize,
                      "current-page": _vm.pagination.pageNum,
                      layout: _vm.paginationLayout,
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }